import React from 'react';

import { Skeleton, SkeletonTheme, UiKit } from 'components';

export default function Loader({ isLoading = false, children = null }) {
  if (!isLoading) {
    return children;
  }

  const units = Array.from({ length: 6 }).map((_, index) => (
    <UiKit.Chip key={index} size="lg" className="cursor-not-allowed">
      <UiKit.Flex gap={4} align="center">
        <Skeleton width={16} height={24} />
        <Skeleton width={44} height={24} />
      </UiKit.Flex>
    </UiKit.Chip>
  ));

  return (
    <SkeletonTheme className="m-0">
      <UiKit.Grid gap={16}>{units}</UiKit.Grid>
    </SkeletonTheme>
  );
}
